import React, { useContext } from 'react';
import BreadCrumbs, {
  BreadcrumbContext,
} from 'chameleon/ui-stack/ui/basic/breadcrumbs';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import Tooltip from 'chameleon/ui-stack/ui/base/tooltip';
import { getDefaultBreadcrumb } from 'chameleon/src/components/results/utils/utils';

const FauxdalNav = ({ router, closeAriaLabel = 'Close results' }) => {
  const { dispatch, breadCrumbs, ACTIONS } = useContext(BreadcrumbContext);
  const onClick = () => {
    const firstBreadcrumb =
      (breadCrumbs.length > 0 && breadCrumbs[0]) ||
      getDefaultBreadcrumb(router?.params?.subject);

    if (firstBreadcrumb) {
      if (router?.location?.state?.focusedElement) {
        router.push({
          pathname: firstBreadcrumb.to,
          state: { focusedElement: router?.location?.state?.focusedElement },
        });
      } else {
        router.push(firstBreadcrumb.to);
      }
    }
    dispatch({
      type: ACTIONS.removeAdjacentBreadCrumbs,
      payload: firstBreadcrumb.text,
    });
  };

  return (
    <div className="flex h-16 border-b border-gray-400">
      <BreadCrumbs />
      <div className="flex justify-center w-16 ml-auto border-l border-gray-400">
        <Tooltip description={closeAriaLabel} position="left">
          <ButtonWithIcon
            isIcon
            isNaked
            aria-label="Close"
            icon="close"
            onClick={onClick}
            className="self-center"
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default FauxdalNav;
